import React, { useEffect, useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import {
    Row, Label, InputGroup, InputGroupAddon, InputGroupText,
    ModalHeader, ModalBody, ModalFooter, Modal, Button, Input, Alert
} from "reactstrap";
import Moment from 'moment';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { GetNotificaciones, GetNotificacionesNuevas, GetUsuarios } from "../queries/Queries";
import { set } from "react-hook-form";

function Notificaciones({
    usuario,
    valorDeREtorno,
}) {

    const [modalCP, setModalCP] = useState(false);
    const toggleCP = () => setModalCP(!modalCP);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [searchBy, setSearchBy] = useState("descripción");
    const [search, setSearch] = useState("");
    const [notificacionesTodas, setNotificacionesTodas] = useState(false);
    const [notificacionesSinFiltro, setNotificacionesSinFiltro] = useState([]);
    const [notificaciones, setNotificaciones] = useState([]);

    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));
    const [totalRecords, setTotalRecords] = useState(0);
    const [pUsuarios, setPUsuarios] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [paginas, setPaginas] = useState([]);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);

    // total records per page to display
    const recordPerPage = 20;

    //Método useEffect
    useEffect(() => {
        fetchUsuarios();

    }, []);

    async function fetchUsuarios() {
        const apiDataU = await GetUsuarios({ usuario: { eq: usuario } });
        if (apiDataU[0]) {
            setPUsuarios(apiDataU[0]);
        } else {
            setPUsuarios({});
        }

    }
    function cerrar() {
        valorDeREtorno({ completo: true });
        toggleCP();
    }

    function onChangesRFecha(e) {
        e.persist()
        var fechafin = rfechafin;
        var fechaini = rfechaini;
        if (e.target.name === "fechaIni") {
            setRfechaini(e.target.value);
            fechaini = e.target.value;
        }
        else {
            setRfechafin(e.target.value);
            fechafin = e.target.value;
        }
        //fetchTickets(fechaini, fechafin);
    }

    //Obtiene los datos de las notificaciones
    async function fetchNotificaciones(usuario, todo) {

        setCargando(true);
        setAVisible(false)
        //Se obtienen las notificaciones
        const apiData = todo ? await GetNotificaciones({ usuarioPara: { contains: usuario } }) :
            await GetNotificacionesNuevas({ usuarioPara: { eq: usuario } });
        //Se agrupan las notificaciones
        const notificacionesOrdenadas = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
        setNotificacionesSinFiltro(notificacionesOrdenadas);
        const notificSF = notificacionesOrdenadas;

        busquedaNotificaciones(notificacionesOrdenadas, searchBy, search, currentPage);
        //Se retornan los datos de notificaciones
        //setNotificaciones(notificacionesOrdenadas);
    }

    async function busquedaNotificaciones(notificacionsinf, searchb, search, currentPage) {
        var pag = 1;
        var bandera = 1;
        var paginasp = [];

        //Filtrado de datos por la búsqueda y el estado de ticket
        const ticketsFromAPI = notificacionsinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(notific =>
                searchb === "descripción" ? notific.notificacion.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "estatus" ? notific.leido === (search === "Leída" ? true : false) :
                        notific.fecha == search);


        await Promise.all(ticketsFromAPI.map(async notific => {
            //producto.indexnum=bandera;
            notific.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                paginasp.push({ pagina: pag });
                pag++;
            }

            return notific;
        }))


        const lengthnotific = ticketsFromAPI.length;
        if (lengthnotific <= 0)
            setCurrentPage(1);

        setNotificaciones(ticketsFromAPI.filter(paginacion => paginacion.indexpag === currentPage).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
        //TicketsFromAPI.filter(paginacion => paginacion.indexpag === pageNumber)
        setTotalRecords(lengthnotific);
        const prepaginas = parseInt(lengthnotific / recordPerPage);
        const paginas = prepaginas * recordPerPage < lengthnotific ? prepaginas + 1 : prepaginas;
        if (paginas > paginasp.length)
            paginasp.push({ pagina: paginas })

        if (currentPage > 1 && lengthnotific > 0) {
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const notificFromAPIp = ticketsFromAPI.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(notific =>
                        notific.indexpag === paginas);
                setNotificaciones(notificFromAPIp.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
            }
        }

        if (lengthnotific > 0) {
            setPaginas(paginasp);
            setultimoNumeroP(paginasp[paginasp.length - 1].pagina)
        } else {
            setPaginas([]);
            setultimoNumeroP(0)
        }
        setCargando(false);
    }
    async function verNotificaciones(produccion) {
        setCargando(true);
        //valorDeREtorno("Mensaje de Carga e inspección");
        fetchNotificaciones(usuario, notificacionesTodas)
        toggleCP();
        setCargando(false);

    }
    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        //if (search && e.target.value !== "fecha")
        busquedaNotificaciones(notificacionesSinFiltro, e.target.value, search, currentPage);
    }
    function onSearch(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busquedaNotificaciones(notificacionesSinFiltro, searchBy, e.target.value, currentPage);
    }
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busquedaNotificaciones(notificacionesSinFiltro, searchBy, e.target.value, currentPage);
    }
    function onNotificacionesTodas(todasN) {
        setAVisible(false);
        setNotificacionesTodas(todasN);
        //busquedaNotificaciones(notificacionesSinFiltro, searchBy, search, currentPage);
        fetchNotificaciones(usuario, todasN)
    }
    function recargar() {
        fetchNotificaciones(usuario, notificacionesTodas)
    }
    //Método que maneja los cambios de página
    function handlePageChangeTickets(TicketsFromAPI, pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPage(pageNumber);
        busquedaNotificaciones(notificacionesSinFiltro, searchBy, search, pageNumber);
    }

    return (
        <>

            <span className="notificacion"
                onClick={() => verNotificaciones(usuario)}
                title={"Ver todas las notificaciones"}>
                <IoIcons.IoIosArrowDown />

            </span>
            <Modal isOpen={modalCP} toggle={toggleCP} size="xl" >
                <ModalHeader toggle={toggleCP}>
                    Notificaciones
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <img width="150px" src="assets/img/preloader.gif" />
                            </div>
                        )}
                    </Row>
                    <Row>
                        <div class="col-lg-6 col-md-9 col-sm-12 col-xs-12 text-left  margintopmobil20px" >
                            <InputGroup></InputGroup>
                            <Label><h5>Busqueda por: </h5></Label>
                            <select name="searchBy" className="ml-2" onChange={buscarpor}>
                                <option value="descripción" selected={searchBy === "descripción" ? true : false}>Descripción</option>
                                <option value="fecha" selected={searchBy === "fecha" ? true : false}> Fecha</option>
                                <option value="estatus" selected={searchBy === "estatus" ? true : false}>Estatus</option>

                            </select>

                            {(searchBy !== "estatus" && searchBy !== "asignado a") && (
                                <Input
                                    name="search"
                                    className=""
                                    type={searchBy !== "fecha" ? "text" : "date"}
                                    placeholder={"Búsqueda por " + searchBy}
                                    onChange={searchBy !== "fecha" ? (e) => setSearch(e.target.value) : onSearchFecha}
                                    onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                                    value={search}
                                />
                            )}
                            {searchBy === "estatus" && (
                                <select name="search" className=" custom-select" onChange={onSearch}>
                                    <option className="" value="" >Elige una opción </option>
                                    <option value="Leída" selected={search === "Leída" ? true : false} >Leído</option>
                                    <option value="NoLeída" selected={search === "NoLeída" ? true : false} >No Leído</option>
                                </select>
                            )}

                        </div>
                        <div className=" form-group  col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-2 "></div>
                        {/*notificacionesTodas && (
                            <div className=" form-group  col-lg-3 col-md-12 col-sm-12 col-xs-12 ">
                                <InputGroup >
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>Del:</InputGroupText>
                                    </InputGroupAddon>
                                    <Input name="fechaIni" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                                </InputGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>Al:</InputGroupText>
                                    </InputGroupAddon>
                                    <Input name="fechaFin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFecha} />
                                </InputGroup>
                            </div>
                        )*/}
                        {/*!notificacionesTodas && (
                            <div className=" form-group  col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-2">
                            </div>
                        )*/}
                    </Row>
                    <Row>
                        <div class={notificacionesTodas ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left " :
                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left mt-3 "
                        } >

                            <Label className="floatleft"><input type="checkbox" name="VUAP" onChange={(e) => onNotificacionesTodas(e.target.checked)} className='ml-2' checked={notificacionesTodas} /> Todas las notificaciones</Label>

                            <button className="cbutton btn-dark floatright " title="Recargar página" onClick={recargar} ><IoIcons.IoMdRefresh /> Recargar </button>
                        </div>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll mt-2">
                            <Table className="mb-2 ">
                                <Thead class="thead-secondary">
                                    <Tr>
                                        <Th >Número</Th>
                                        <Th >Fecha</Th>
                                        <Th >hora</Th>
                                        <Th >Descripción</Th>
                                        <Th>Estatus</Th>
                                        {/*<Th >Acciones</Th>*/}
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {notificaciones.map((notificacion, i) => (
                                        <Tr className={(i % 2) !== 0 ? "table-active" : ""}>
                                            <Td>{i + 1}</Td>
                                            <Td>{notificacion.fecha}</Td>
                                            <Td>{notificacion.hora}</Td>
                                            <Td className="margintopmobil20px">{notificacion.notificacion}</Td>
                                            <Td className="margintopmobil20px">{notificacion.leido ? "Leído" : "No leído"}</Td>
                                            {/*<Td> {pUsuarios.nombreCompleto}</Td>*/}
                                            {/*<Td className="margintopmobil40px">
                                            <button class="btn-info cbutton mt-1 ml-1" onClick={() => clicAccion(notificacion, "Detalle de notificacion")} title="Detalles"> <IoIcons.IoIosListBox />  </button>
                                            <button class="btn-primary cbutton mt-1 ml-1" onClick={() => clicEditar(notificacion)} title="Editar"> <IoIcons.IoIosCreate />  </button>
                                        </Td>*/}
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>
                        <div className="mt-3 mb-3 textaligmentcenter col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter ">
                            <div class="floatcenter">
                                <ul class="pagination">
                                    <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                                        <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangeTickets(notificacionesSinFiltro, 1)}>«</a>
                                    </li>
                                    <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                                        <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangeTickets(notificacionesSinFiltro, currentPage - 1)}>⟨</a>
                                    </li>
                                    {paginas.map(pagina => (
                                        <li class={currentPage === pagina.pagina ? "page-item active" : "page-item "}>
                                            <a class="page-link " onClick={() => handlePageChangeTickets(notificacionesSinFiltro, pagina.pagina)}>{pagina.pagina}</a>
                                        </li>
                                    ))}
                                    <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                        <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangeTickets(notificacionesSinFiltro, currentPage + 1)}>⟩</a>
                                    </li>
                                    <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                        <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangeTickets(notificacionesSinFiltro, ultimoNumeroP)}>»</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={cerrar}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
export default Notificaciones;
